/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CategoryResponseDto,
  CreateCategoryDto,
  ListCategoriesQueryControllerListParams,
  ListCategoriesResponseDto,
  UpdateCategoryDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a category (platform admin only)
 */
export const createCategoryCommandControllerCreate = (
  createCategoryDto: CreateCategoryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CategoryResponseDto>({
    url: `/v1/categories`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createCategoryDto,
    signal,
  });
};

export const getCreateCategoryCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>,
    TError,
    { data: CreateCategoryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>,
  TError,
  { data: CreateCategoryDto },
  TContext
> => {
  const mutationKey = ["createCategoryCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>,
    { data: CreateCategoryDto }
  > = (props) => {
    const { data } = props ?? {};

    return createCategoryCommandControllerCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>
>;
export type CreateCategoryCommandControllerCreateMutationBody =
  CreateCategoryDto;
export type CreateCategoryCommandControllerCreateMutationError = void;

/**
 * @summary Create a category (platform admin only)
 */
export const useCreateCategoryCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>,
      TError,
      { data: CreateCategoryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCategoryCommandControllerCreate>>,
  TError,
  { data: CreateCategoryDto },
  TContext
> => {
  return useMutation(
    getCreateCategoryCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List categories (ordered by sortOrder)
 */
export const listCategoriesQueryControllerList = (
  params?: ListCategoriesQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListCategoriesResponseDto>({
    url: `/v1/categories`,
    method: "GET",
    params,
    signal,
  });
};

export const getListCategoriesQueryControllerListQueryKey = (
  params?: ListCategoriesQueryControllerListParams,
) => {
  return [`/v1/categories`, ...(params ? [params] : [])] as const;
};

export const getListCategoriesQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
  TError = void,
>(
  params?: ListCategoriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCategoriesQueryControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCategoriesQueryControllerList>>
  > = ({ signal }) => listCategoriesQueryControllerList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCategoriesQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCategoriesQueryControllerList>>
>;
export type ListCategoriesQueryControllerListQueryError = void;

export function useListCategoriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
  TError = void,
>(
  params: undefined | ListCategoriesQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listCategoriesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCategoriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
  TError = void,
>(
  params?: ListCategoriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listCategoriesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCategoriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
  TError = void,
>(
  params?: ListCategoriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List categories (ordered by sortOrder)
 */

export function useListCategoriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
  TError = void,
>(
  params?: ListCategoriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCategoriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCategoriesQueryControllerListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a category — rename, reorder, or set active (platform admin only)
 */
export const updateCategoryCommandControllerUpdate = (
  id: string,
  updateCategoryDto: UpdateCategoryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CategoryResponseDto>({
    url: `/v1/categories/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: updateCategoryDto,
    signal,
  });
};

export const getUpdateCategoryCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>,
    TError,
    { id: string; data: UpdateCategoryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateCategoryDto },
  TContext
> => {
  const mutationKey = ["updateCategoryCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>,
    { id: string; data: UpdateCategoryDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCategoryCommandControllerUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>
>;
export type UpdateCategoryCommandControllerUpdateMutationBody =
  UpdateCategoryDto;
export type UpdateCategoryCommandControllerUpdateMutationError = void;

/**
 * @summary Update a category — rename, reorder, or set active (platform admin only)
 */
export const useUpdateCategoryCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>,
      TError,
      { id: string; data: UpdateCategoryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCategoryCommandControllerUpdate>>,
  TError,
  { id: string; data: UpdateCategoryDto },
  TContext
> => {
  return useMutation(
    getUpdateCategoryCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
/**
 * Marks the category inactive. It is hidden from new-task pickers but remains attached to existing tasks.
 * @summary Soft-disable a category (platform admin only)
 */
export const deactivateCategoryCommandControllerDeactivate = (
  id: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/categories/${id}`,
    method: "DELETE",
    signal,
  });
};

export const getDeactivateCategoryCommandControllerDeactivateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deactivateCategoryCommandControllerDeactivate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateCategoryCommandControllerDeactivate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateCategoryCommandControllerDeactivateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>
  >;

export type DeactivateCategoryCommandControllerDeactivateMutationError = void;

/**
 * @summary Soft-disable a category (platform admin only)
 */
export const useDeactivateCategoryCommandControllerDeactivate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateCategoryCommandControllerDeactivate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeactivateCategoryCommandControllerDeactivateMutationOptions(options),
    queryClient,
  );
};
